module.exports = __webpack_public_path__ + "fonts/SamsungOne-400v10.4173044d.woff";